<section class="matchday-outer">
    <!--page starts-->
    <section class="page-wrapper matchday-section margin-top-152">
        <div class="container">
             <div class="matchday-detail ">
                <div class="titel-box">
					<h2 class="titel-name">CUSTOMER CONTACT INFORMATION</h2>
				</div>
                <div class="matchday-top-detail">
                    <div class="matchday-top-content">
                        <p>In order to comply with Government COVID-19 Guidance, we must obtain contact details of all persons attending a Fixture or Event at the Uptonsteel County Ground for full track and trace purposes.</p>
                        <p>We ask that the lead person, who has made the ticket booking, to complete the below information and submit the form back to the club.</p>
                        <p>Under the Government Guidance, customer contact information will only be held for 21 days from completion and then it will be securely deleted. </p>
                        <h3>If you have any queries, please call email <a href="mailto:enquiries@leicestershireccc.co.uk">enquiries@leicestershireccc.co.uk</a> or call 0116 283 2128.</h3>
                        
                    </div>
                    <http-message types="success" [data]="attendanceSuccess" class="err-msg-block"></http-message>
                    <http-message [type]="'error'" [data]="attendanceError" *ngIf="attendanceError" class="err-msg-block"></http-message>
                    <form class="matchday-top-form" #attendanceForm="ngForm" (ngSubmit)="addAttendance(attendanceForm)" [ngClass]="{ hidden: attendanceSuccess }">
                       
                        <h4>LEAD BOOKERS NAME*</h4>
                        <div class="matchday-top">
                            <div>
                                <div class="matchday-top-input-box half mr mb">
                                    <app-form-field validation="required" name="first_name" [(ngModel)]="attendanceRequest.first_name"
                                                            class="app-group">
                                    <input type="text" appFieldInput placeholder="First Name" class="input-style">
                                </app-form-field>
                                </div>
                                <div class="matchday-top-input-box half mb">
                                    <app-form-field validation="required" name="last_name" [(ngModel)]="attendanceRequest.last_name"
                                                            class="app-group">
                                    <input type="text" appFieldInput placeholder="Last Name" class="input-style">
                                </app-form-field>
                                </div>
                                <div class="matchday-top-input-box half mr">
                                    <app-form-field  name="booking_reference" [(ngModel)]="attendanceRequest.booking_reference"
                                                            class="app-group">
                                        <input type="text" appFieldInput placeholder="Booking Reference (if you have it)" class="input-style">
                                    </app-form-field>
                                </div>
                                <div class="matchday-top-input-box half">
                                    <div class="custom-select" class="input-style">
                                        
                                        <select id="select_match" (change)="selectmatch()">
                                          <option value="">Select Title</option>
                                          <option value="{{match?.attendance_title_id}}" *ngFor="let match of titleList?.data">{{match?.title}}</option>
                                          <!-- <option value="1">WHICH FIXTURE ARE YOU ATTENDING</option>
                                          <option value="2">WHICH FIXTURE ARE YOU ATTENDING</option> -->
                                        </select>
                                       
                                    </div>
                                    <div class="invalid-feedback  attnderror" id="select_match-msg">Title is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="matchday-outer-inner">
                            <div class="matchday-center">
                                <!-- <div class="matchday-center-attendee">
                                    <p>ATTENDEE  01</p>
                                </div> -->
                                <div class="matchday-center-add-attendee">
                                    <a (click)="addcol()">ADD Attendee</a>
                                </div>
                            </div>
                            <div class="matchday-bottom">
                                <div>
                                    <div class="bottom-main"> 
                                        <div class="matchday-bottom-inner">
                                            <div class="matchday-center-attendee full ">
                                                <p>ATTENDEE  1</p>
                                            </div>
                                            <div class="matchday-top-input-box half mr mb">
                                                <input type="text" placeholder="First Name" id="firstname1" class="input-style firstname">
                                                <div class="invalid-feedback  attnderror" id="firstname1-msg">First name is required</div>
                                            </div>
                                            <div class="matchday-top-input-box half mb">
                                                <input type="text" placeholder="Last Name" id="lastname1" class="input-style">
                                                <div class="invalid-feedback  attnderror" id="lastname1-msg">Last name is required</div>
                                            </div>
                                            <div class="matchday-top-input-box half mr mb">
                                                <input type="number" placeholder="Mobile Number" id="mobilenumber1" class="input-style">
                                                <div class="invalid-feedback  attnderror" id="mobilenumber1-msg">Mobile Number is required</div>
                                                <div class="invalid-feedback  attnderror" id="mobilenumber1-validmsg">Please enter minimum 10 digit Mobile Number</div>
                                            </div>
                                            <div class="matchday-top-input-box half mb">
                                                <input type="email" placeholder="Email Address" id="emailaddress1" class="input-style">
                                                <div class="invalid-feedback  attnderror" id="emailaddress1-msg">Email is required</div>
                                                <div class="invalid-feedback  attnderror" id="emailaddress1-validmsg">Please enter valid email</div>
                                                <!-- <div class="custom-select" class="input-style">
                                                    <select>
                                                    <option value="0">Email Address</option>
                                                    </select>
                                                </div> -->
                                            </div>
                                            <div class="matchday-top-input-box full mb">
                                                <input type="text" id="address1" placeholder="Address" class="input-style">
                                                <div class="invalid-feedback  attnderror" id="address1-msg">Address is required</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="matchday-bottom-content full">
                                        <p>Please note that without providing contact details for each attendee, the club are unable to issue your tickets.</p>
                                    </div>
                                    <div class="matchday-bottom-check-box full">
                                        <label class="container">Please check this box to confirm that the information provided in this form, for all attendees is accurate and correct.
                                            <input type="checkbox" id="attendencecheck">
                                            <span class="checkmark"></span>
                                        </label>
                                        <div class="invalid-feedback  attnderror" id="attendencecheck-msg">Check box is required</div>
                                    </div>
                                    <div class="matchday-bottom-btn full">
                                        <button type="submit">SUBMIT FORM</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
             </div>   
        </div>
    </section><!-- page ends-->
</section>